export enum TalkJsUserRole {
  STAFF = 'Staff',
  USER = 'client',
}
